const validateWeighting = (columnsWithWeights, accessKey = 'weight') => {
  const total = columnsWithWeights.reduce((prev, current) => prev + current[accessKey], 0);
  return total === 1 && columnsWithWeights.every(x => x.weight > 0);
};

export default validateWeighting;
